//
//
//
//
//
//
//
//
//
//
//
//

import LogList from "@/components/Query/LogList";
export default {
  name: "VillageLogList",
  data() {
    return {};
  },
  components: { LogList },
  mounted() {},
};
